import React, { useMemo } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Text } from '@ui/atoms/Text';
import { Tag } from '@ui/atoms/Tag';
import { Button, Table, TableSize } from '@ui';
const sampleFolders = [
    {
        id: 1,
        name: 'QA Drop Package',
        expiresAt: '2026-11-13T05:00:00Z',
        createdAt: '2026-08-14T12:00:00Z',
        createdBy: 'lee@inspectpoint.com',
        filesCount: 0,
        locked: false,
        lockedAt: null,
        lockedBy: null
    },
    {
        id: 2,
        name: 'District Migration',
        expiresAt: '2026-09-01T00:00:00Z',
        createdAt: '2026-08-01T12:00:00Z',
        createdBy: 'admin@example.com',
        filesCount: 128,
        locked: true,
        lockedAt: '2026-08-14T18:00:00Z',
        lockedBy: 'lee@inspectpoint.com'
    }
];
const columns = [
    {
        dataKey: 'name',
        label: 'Name',
        columnType: 'primary',
        renderer: ({ item }) => (React.createElement("button", { type: "button", className: "folder-list__name-btn" },
            React.createElement("i", { className: "fa-light fa-folder", "aria-hidden": "true" }),
            React.createElement(Text, { variant: "body" }, item.name)))
    },
    {
        dataKey: 'expiresAt',
        label: 'Expires',
        renderer: ({ item }) => (React.createElement(Tag, { label: `Expires ${new Date(item.expiresAt).toLocaleDateString()}`, variant: "gray" }))
    },
    {
        dataKey: 'filesCount',
        label: 'Files',
        align: 'right'
    },
    {
        dataKey: 'id',
        label: 'Actions',
        columnType: 'action',
        renderer: () => (React.createElement(Button, { variant: "secondary" },
            React.createElement("i", { className: "fa-light fa-trash", "aria-hidden": "true" })))
    }
];
const meta = {
    title: 'Features/CustomerFileDrop/FolderTable',
    tags: ['autodocs'],
    parameters: { layout: 'padded' }
};
export default meta;
/** Presentational Quimby Table used by FolderList (data wired in the live page). */
export const Populated = {
    render: () => (React.createElement(Table, { data: sampleFolders, columns: columns, size: TableSize.Full, variant: "listing", getItemId: (folder) => folder.id, onPageChange: () => undefined, serverCurrentPage: 1, serverTotalPages: 1, serverTotalItems: sampleFolders.length, pageSize: 25 }))
};
export const Empty = {
    render: () => (React.createElement("div", { className: "folder-list__empty" },
        React.createElement(Text, { variant: "body" }, "No folders yet. Create one to get started.")))
};
export const PageShell = {
    render: () => {
        const client = useMemo(() => new QueryClient({ defaultOptions: { queries: { retry: false } } }), []);
        return (React.createElement(QueryClientProvider, { client: client },
            React.createElement("div", { className: "customer-file-drop", "data-testid": "file-drop-page" },
                React.createElement("header", { className: "customer-file-drop__header" },
                    React.createElement(Text, { variant: "x-large", as: "h1" }, "Customer File Drop"),
                    React.createElement(Button, { variant: "secondary", "data-testid": "manage-allowlist-button" },
                        React.createElement("i", { className: "fa-light fa-users", "aria-hidden": "true" }),
                        " User Access")),
                React.createElement("main", { className: "customer-file-drop__main" },
                    React.createElement("div", { className: "folder-list__header" },
                        React.createElement(Text, { variant: "large", as: "h2" }, "Folders"),
                        React.createElement(Button, { "data-testid": "create-folder-button" },
                            React.createElement("i", { className: "fa-light fa-plus", "aria-hidden": "true" }),
                            " Create Folder")),
                    React.createElement(Table, { data: sampleFolders, columns: columns, size: TableSize.Full, variant: "listing", getItemId: (folder) => folder.id })))));
    }
};
